<template>
  <div>
    <transition name="height0">
      <div class="benefit-sku-input" v-if="showAccount">
        <div
          class="benefit-input-label"
          :style="`pointer-events: ${
            selectSku.allowed_recharge_account_types.length > 1
              ? 'initial'
              : 'none'
          }`"
          @click="showSelectRechargePopup = true"
        >
          充值{{ topUpText
          }}<svg-icon
            v-if="selectSku.allowed_recharge_account_types.length > 1"
            class="benefit-input-label-arrow"
            iconClass="arrow"
          />
          <span v-else>：</span>
        </div>
        <van-field
          :placeholder="placeholder"
          class="benefit-input"
          :value="phone_account"
          @input="changeAccount"
          :error-message="errorMessage"
          :type="input_type"
        />
      </div>
    </transition>
    <div class="benefit-sku-list" v-if="skuInfo.length > 1">
      <van-row>
        <van-col
          @click="skuChange(item, idx)"
          :class="{
            'sku-item': true,
            'sku-flex': !!item.image,
            active: item.id === selectSku.id,
          }"
          :span="12"
          v-for="(item, idx) in filterSkuInfo"
          :key="item.id"
        >
          <div
            :class="{
              'sku-item-inner': true,
              'new-image': true,
            }"
          >
            <van-image
              lazy-load
              class="sku-item-inner-image"
              :src="item.image"
              fit="contain"
            />
            <div
              v-if="item.image"
              :class="{
                'sku-item-name': true,
              }"
            >
              {{ item.platform_product_name || item.item_name }}
            </div>
            <div v-if="item.status === 0" class="out-stock">无货</div>
          </div>
        </van-col>
      </van-row>
    </div>
    <div
      v-if="skuInfo.length > 6"
      class="benefit-sku-fold"
      @click="fold = !fold"
    >
      {{ fold ? "更多权益" : "收起权益" }}
      <svg-icon
        class="benefit-sku-fold-arrow"
        :iconClass="fold ? 'chevron-down' : 'chevron-up'"
      />
    </div>
    <select-popup
      title="选择账号充值类型"
      :value="selectSku.recharge_account_number"
      @update:value="changeRechargeAccountNumber"
      :options="selectSku.allowed_recharge_account_types"
      :optionFieldMap="{
        label: 'account_type_name',
        value: 'account_type_number',
      }"
      v-model="showSelectRechargePopup"
    />
  </div>
</template>

<script>
import SelectPopup from "@/components/selectPopup";

import { mapState } from "vuex";

export default {
  props: {
    skuInfo: Array,
    selectSku: Object,
    showAccount: Boolean,
    updateSelectSku: Function,
    phone_account: String,
  },
  components: {
    SelectPopup,
  },
  data() {
    const { detail_type } = this.$route.query;
    return {
      showSelectRechargePopup: false,
      errorMessage: "",
      fold: detail_type ? false : true, // 指定sku后不折叠
    };
  },
  computed: {
    ...mapState(["namespace"]),
    input_type() {
      return this.selectSku.recharge_account_number === 1 ? "tel" : "text";
    },

    placeholder() {
      return "请输入" + this.topUpText;
    },
    topUpText() {
      return (
        this.selectSku.allowed_recharge_account_types?.find(
          (item) =>
            item.account_type_number === this.selectSku.recharge_account_number
        )?.account_type_name || "充值账号"
      );
    },
    filterSkuInfo() {
      if (this.fold) {
        return this.skuInfo.slice(0, 6);
      } else {
        return this.skuInfo;
      }
    },
  },
  methods: {
    skuChange(item, idx) {
      if (item.item_code === this.selectSku.item_code) return;
      this.updateSelectSku(item);
      this.errorMessage = "";
    },
    changeRechargeAccountNumber(type) {
      this.updateSelectSku({
        ...this.selectSku,
        recharge_account_number: type,
      });
    },

    changeAccount(e) {
      if (this.selectSku.recharge_account_number === 1) {
        let s = e.replace(/(^\d{3}|\d{4}\B)/g, "$1 ").replace("  ", " ");
        this.$emit("update:phone_account", s);
        const currentAccount = e.replace(/ /g, "");
        if (currentAccount.length && currentAccount.length !== 11) {
          this.errorMessage = "请输入正确的手机号";
        } else {
          this.errorMessage = "";
        }
        return;
      }
      this.$emit("update:phone_account", e);
    },
  },
};
</script>